export const viVN_notification = {
  'app.notification.success': 'Thành công!',
  'app.notification.error': 'Lỗi!'
};
